export const MDash = "\u2014"

export const Dot = "•"

export const DotSmall = "·"

export const NDash = "–"

export const Minus = "\u{2212}"

export const Plus = "+"

export const PlusMinus = "±"

export const Times = "×"

export const ArrowUp = "↑"

export const FatArrowUp = "⬆"

export const ArrowDown = "↓"

export const ArrowRight = "→"

export const ArrowLeft = "←"

export const InfinitySymbol = "∞"

export const KoreanWon = "₩"

export const Ellipsis = "…"

export const NoBreakSpace = "\u{00A0}"

export const SmallAsterisk = "\uFE61"

export const checkMark = "\uE94F"

export const checkMarkBold = "\uE99D"

export const numbersInCircle = ["🄋", "➀", "➁", "➂", "➃", "➄", "➅", "➆", "➇", "➈", "➉"]

export const DoubleQuotationStart = "“"

export const DoubleQuotationEnd = "”"

export const SingleQuotationStart = "‘"

export const SingleQuotationEnd = "’"

export const Square = "□"
